import React from 'react';
import { useNavigate } from 'react-router-dom';

const ProductCard = ({ 
  product, 
  index = 0, 
  showRating = true, 
  showDescription = true, 
  className = "",
  onClick 
}) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    if (onClick) {
      onClick(product.id);
    } else {
      navigate(`/product/${product.id}`);
    }
  };

  const handleButtonClick = (e) => {
    e.stopPropagation(); // Prevent card click when button is clicked
    if (onClick) {
      onClick(product.id);
    } else {
      navigate(`/product/${product.id}`);
    }
  };

  return (
    <div 
      className={`product-card group cursor-pointer hover-lift stagger-item flex flex-col ${className}`}
      onClick={handleCardClick}
      style={{ animationDelay: `${index * 0.1}s` }}
    >
      {/* Product Image */}
      <div className="h-64 rounded-t-xl overflow-hidden relative flex-shrink-0">
        <img 
          src={product.image} 
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
      </div>

      {/* Product Content */}
      <div className="p-6 flex flex-col flex-grow">
        {/* Product Name */}
        <h3 className="text-xl font-semibold text-black mb-2">
          {product.name}
        </h3>

        {/* Product Description - Optional */}
        {showDescription && (
          <p className="text-gray-600 text-sm mb-4 line-clamp-2">
            {product.description}
          </p>
        )}

        {/* Spacer to push price and button to bottom */}
        <div className="flex-grow"></div>

        {/* Price and Rating Section */}
        <div className="mt-auto">
          <div className="flex items-center justify-between mb-4">
            {/* Price */}
            <span className="text-2xl font-bold text-black">${product.price}</span>
            
            {/* Rating - Optional */}
            {showRating && (
              <div className="flex space-x-1">
                {[...Array(5)].map((_, i) => (
                  <svg 
                    key={i} 
                    className={`w-4 h-4 ${i < Math.floor(product.rating) ? 'text-amber-400' : 'text-gray-300'}`} 
                    fill="currentColor" 
                    viewBox="0 0 20 20"
                  >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                  </svg>
                ))}
              </div>
            )}
          </div>

          {/* Action Button */}
          <button 
            onClick={handleButtonClick}
            className="w-full bg-black text-white font-medium py-3 px-6 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
          >
            View Details
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
